module.exports = __webpack_public_path__ + "static/media/FICCI-Black-Logo.476f08eb.png";